export const SNAPCHAT_OBJECTIVES = [
  { value: 'AWARENESS_AND_ENGAGEMENT', label: 'Awareness & Engagement', description: 'Maximise impressions and reach on Snapchat' },
  { value: 'TRAFFIC', label: 'Traffic', description: 'Drive swipe-ups to your website' },
  { value: 'LEADS', label: 'Leads', description: 'Collect sign-ups with a Snapchat lead form or your website' },
  { value: 'SALES', label: 'Sales', description: 'Optimise for purchases tracked by your Snap Pixel' },
  { value: 'APP_PROMOTION', label: 'App Promotion', description: 'Drive installs of your iOS / Android app' },
];

export const SNAPCHAT_OPTIMIZATION_GOALS = {
  AWARENESS_AND_ENGAGEMENT: [
    { value: 'IMPRESSIONS', label: 'Impressions' },
    { value: 'SWIPES', label: 'Swipe Ups' },
    { value: 'VIDEO_VIEWS', label: 'Video Views (2s)' },
    { value: 'VIDEO_VIEWS_15_SEC', label: 'Video Views (15s)' },
  ],
  TRAFFIC: [
    { value: 'SWIPES', label: 'Swipe Ups' },
    { value: 'IMPRESSIONS', label: 'Impressions' },
    { value: 'LANDING_PAGE_VIEW', label: 'Landing Page Views' },
  ],
  LEADS: [
    { value: 'LEAD_FORM_SUBMISSIONS', label: 'Lead Form Submissions (Snapchat form)', needs: 'lead_form' },
    { value: 'PIXEL_SIGNUP', label: 'Website Sign-Ups (Snap Pixel)', needs: 'pixel' },
    { value: 'SWIPES', label: 'Swipe Ups' },
  ],
  SALES: [
    { value: 'PIXEL_PURCHASE', label: 'Purchases (Snap Pixel)', needs: 'pixel' },
    { value: 'PIXEL_ADD_TO_CART', label: 'Add to Cart (Snap Pixel)', needs: 'pixel' },
    { value: 'PIXEL_PAGE_VIEW', label: 'Page Views (Snap Pixel)', needs: 'pixel' },
    { value: 'PIXEL_SIGNUP', label: 'Sign-Ups (Snap Pixel)', needs: 'pixel' },
  ],
  APP_PROMOTION: [
    { value: 'APP_INSTALLS', label: 'App Installs', needs: 'app' },
    { value: 'APP_PURCHASE', label: 'In-App Purchases', needs: 'app' },
    { value: 'APP_SIGNUP', label: 'In-App Sign-Ups', needs: 'app' },
    { value: 'APP_ADD_TO_CART', label: 'In-App Add to Cart', needs: 'app' },
  ],
};

export const SNAPCHAT_APP_CTA_TYPES = [
  { value: 'INSTALL_NOW', label: 'Install Now' },
  { value: 'DOWNLOAD', label: 'Download' },
  { value: 'PLAY', label: 'Play' },
  { value: 'USE_APP', label: 'Use App' },
];

export const defaultSnapConversion = () => ({ pixelId: '', leadFormId: '', snapAppId: '', appName: '', iosAppId: '', androidAppUrl: '', iconMediaId: '', iconFileName: '' });

export const snapGoalFor = (objective, goal) => {
  const goals = SNAPCHAT_OPTIMIZATION_GOALS[objective] || [];
  return goals.find((g) => g.value === goal) || goals[0] || null;
};

export const SNAPCHAT_CTA_TYPES = [
  { value: 'MORE', label: 'More' },
  { value: 'SHOP_NOW', label: 'Shop Now' },
  { value: 'SIGN_UP', label: 'Sign Up' },
  { value: 'APPLY_NOW', label: 'Apply Now' },
  { value: 'BOOK_NOW', label: 'Book Now' },
  { value: 'ORDER_NOW', label: 'Order Now' },
  { value: 'GET_NOW', label: 'Get Now' },
  { value: 'VIEW', label: 'View' },
  { value: 'WATCH', label: 'Watch' },
  { value: 'READ', label: 'Read' },
  { value: 'PLAY', label: 'Play' },
  { value: 'LISTEN', label: 'Listen' },
];

export const SNAPCHAT_LIMITS = { brandName: 32, headline: 34, maxUploadMB: 32 };

export const SNAPCHAT_POSITIONS = [
  { value: 'INTERSTITIAL_USER', label: 'Between Friends’ Stories' },
  { value: 'INTERSTITIAL_CONTENT', label: 'Between Content (Discover)' },
  { value: 'INSTREAM', label: 'Within Publisher & Creator Stories' },
  { value: 'PUBLIC_STORIES_INSTREAM', label: 'Within Public Stories' },
  { value: 'INTERSTITIAL_SPOTLIGHT', label: 'Spotlight' },
  { value: 'FEED', label: 'Discover Feed Tiles' },
  { value: 'CAMERA', label: 'Camera (Lenses)' },
];

export const SNAPCHAT_BID_STRATEGIES = [
  { value: 'AUTO_BID', label: 'Auto-Bid (recommended)', description: 'Snapchat sets bids to get the most results for your budget' },
  { value: 'LOWEST_COST_WITH_MAX_BID', label: 'Max Bid', description: 'Never pay more than your maximum bid per result' },
  { value: 'TARGET_COST', label: 'Target Cost', description: 'Keep the average cost per result near your target' },
];

export const SNAPCHAT_PACING = [
  { value: 'STANDARD', label: 'Standard (spread evenly)' },
  { value: 'ACCELERATED', label: 'Accelerated (spend as fast as possible)' },
];

export const SNAPCHAT_BRAND_SAFETY = [
  { value: 'FULL_INVENTORY', label: 'Full Inventory (default)' },
  { value: 'LIMITED_INVENTORY', label: 'Limited Inventory (Creator stories only)' },
];

export const SNAPCHAT_OS_TYPES = ['iOS', 'ANDROID', 'WEB'];
export const SNAPCHAT_CONNECTION_TYPES = [{ value: 'WIFI', label: 'Wi-Fi' }, { value: 'CELL', label: 'Cellular' }];

export const defaultSnapTargeting = () => ({
  interestsInclude: [], interestsExclude: [], segmentsInclude: [], segmentsExclude: [], languages: [],
  osTypes: [], connectionTypes: [], carrierIds: [], regionIds: [], autoExpansion: true, smartTargeting: false, regulatedContent: false,
});

export const defaultSnapDelivery = () => ({
  placement: 'AUTOMATIC', positions: [], pacing: 'STANDARD', bidStrategy: 'AUTO_BID', bidAmount: '',
  frequencyCapEnabled: false, frequencyCapCount: 3, frequencyCapDays: 7, brandSafety: 'FULL_INVENTORY',
});

export const snapchatAdsManagerUrl = (adAccountId) => `https://ads.snapchat.com/${adAccountId}/campaigns`;
